export var SubscriptionEventType;
(function (SubscriptionEventType) {
    SubscriptionEventType["added"] = "added";
    SubscriptionEventType["changed"] = "changed";
    SubscriptionEventType["ready"] = "ready";
    SubscriptionEventType["removed"] = "removed";
})(SubscriptionEventType || (SubscriptionEventType = {}));
export var TransactionType;
(function (TransactionType) {
    TransactionType["expense"] = "expense";
    TransactionType["income"] = "income";
    TransactionType["internal"] = "internal";
})(TransactionType || (TransactionType = {}));
export var UserRole;
(function (UserRole) {
    UserRole["ACCOUNTANT"] = "ACCOUNTANT";
    UserRole["ADMIN"] = "ADMIN";
    UserRole["SHAREHOLDER"] = "SHAREHOLDER";
})(UserRole || (UserRole = {}));
